import i18next from "i18next";
import getLanguage from "./getLang";

const isLangKo = () => getLanguage() === "ko-KR";

export default isLangKo;
